<template>
  <b-nav-item-dropdown id="profile-dropdown" right v-if="isProjectOpen">
    <template v-slot:text>
      <b-icon-person-lines-fill
        class="menu-icon"
        variant="light"
        height="25px"
        width="25px"
        style="margin-top: -6px"
        v-b-tooltip.hover="$t('editor.dictionnary.profile')"
      />
    </template>
    <b-dropdown-item disabled>
      {{ $t("header.profile") }}
      {{ currentProfile.caption }}
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item
      href="#"
      v-for="profile in profiles"
      :key="profile.id"
      @click.prevent="changeProfile(profile)"
      >{{ profile.caption }}</b-dropdown-item
    >
  </b-nav-item-dropdown>
</template>

<script>
//---- 3rd-parties --------
import { BIconPersonLinesFill } from "bootstrap-vue";

export default {
  components: {
    BIconPersonLinesFill,
  },
  methods: {
    async changeProfile(profile) {

      if (!await this.checkForUnsavedAuthoringModifications())
        return;

      if (!await this.checkForOpenServiceSession(profile))
        return;

      this.$store.dispatch("showGlobalLoadingOverlay", "profile-switch");
      await this.$store.dispatch("projectData/setCallCenterData", {});
      await this.$store.dispatch("projectData/switchProfile", profile);
      if (!this.safeRouterPush("/home")) {
        await this.$store.dispatch("header/reload");
        this.$store.dispatch("hideGlobalLoadingOverlay", "profile switched");
      }
    },
  },
  computed: {
    //checks if the project is open
    isProjectOpen() {
      return this.$store.getters["projectData/isProjectOpen"];
    },
    //gets the current profile data(along with quests info)
    currentProfile() {
      return this.$store.getters["projectData/currentProfile"];
    },
    profiles() {
      return this.$store.getters["projectData/profiles"];
    },
  },
};
</script>
<style scoped>
.nav-item {
  width: 50px !important;
}
</style>